module.exports = __webpack_public_path__ + "img/deposit.02232f2e.png";